import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { AppHeader } from "./AppHeader";
import { Footer } from "./Footer";
import { SidebarNavigation } from "./SidebarNavigation";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { SkipLink } from "@/components/common/SkipLink";

export function Layout() {
  return (
    <SidebarProvider>
      {/* Skip link for keyboard users to bypass navigation (WCAG 2.4.1) */}
      <SkipLink />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <AppHeader />
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          {/* Desktop sidebar - hidden on mobile */}
          <Box sx={{ display: { xs: "none", md: "block" }, position: "relative" }}>
            <SidebarNavigation />
          </Box>
          <Box
            component="main"
            id="main-content"
            tabIndex={-1}
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              // Remove focus outline for main content (receives focus via skip link)
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Outlet />
          </Box>
        </Box>
        <Footer />
      </Box>
    </SidebarProvider>
  );
}
